import { IGraphDataResponse } from '../data/datapoint/useGraphData';
import { useDataPointLookups } from './useDataPointLookups';

export function useCSVExporter(hardwareModelId: string) {
  const { dataPointLookup, isLoading } = useDataPointLookups(hardwareModelId);

  function getColumnHeader(
    dataPointInfo: Record<string, string | undefined>
  ): string {
    if (dataPointInfo.unit) {
      return `${dataPointInfo.name} (${dataPointInfo.unit})`;
    }

    return dataPointInfo.name || 'Unknown DataPoint';
  }

  function fromGraphDataToCSV(data: IGraphDataResponse[]) {
    if (data.length === 0) {
      return [];
    }

    // Build a cache of dataPoint names to avoid repeated lookups
    const datapointCache = new Map<
      string,
      Record<string, string | undefined>
    >();

    data.forEach((dataPoint) => {
      const { datapointId } = dataPoint;

      if (!datapointCache.has(datapointId)) {
        const dp = dataPointLookup(datapointId);
        const name = dp?.name || datapointId;
        const unit = dp?.unit || undefined;
        console.log('Lookup name for', datapointId, ':', name);
        datapointCache.set(datapointId, { name, unit });
      }
    });

    // Create a map of timestamps to their row data
    const timestampMap = new Map<string, Record<string, any>>();

    // Process each dataPoint
    data.forEach((dataPoint) => {
      const { datapointId, data: dataArray } = dataPoint;
      const dataPointInfo = datapointCache.get(datapointId)!;

      // Process each data entry for this dataPoint
      dataArray.forEach((entry) => {
        const { timestamp, readingData } = entry;
        const value = readingData[0]?.transformedValue;

        // Get or create the row for this timestamp
        if (!timestampMap.has(timestamp)) {
          timestampMap.set(timestamp, { Timestamp: timestamp });
        }

        const row = timestampMap.get(timestamp)!;
        row[getColumnHeader(dataPointInfo)] = value;
      });
    });

    // Convert map to array
    return Array.from(timestampMap.values());
  }

  return { fromGraphDataToCSV, isLoading };
}
